import {Component, OnInit, Optional, inject} from '@angular/core';
import {MobileWebViewService} from '@mpt-fo/common/core/services/mobile-web-view.service';
import {NZ_MODAL_DATA, NzModalRef} from 'ng-zorro-antd/modal';
import { DialogMessageType, ActionAfterModalClose } from "@mpt-fo/common/shared/models/utility.model";
import {KamonaDialogDesign, KamonaDialogType} from '@mpt-fo/common/kamona/model/kamonal-model';

@Component({
	selector: 'app-error-modal',
	templateUrl: './error-modal.component.html',
	styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent implements OnInit {
	title: string;
	description: string;
	submitButtonName: string;
	canCalButtonName: string;
	isSuspended: boolean;
	suspensionReleaseTime: any;
	showFullButton: boolean;
	actionAfterModalClose: any;
	modalDesign: KamonaDialogDesign = KamonaDialogDesign.NEW;
	dialogType: KamonaDialogType = KamonaDialogType.MAXIMIZE;
	messageType: DialogMessageType = DialogMessageType.SUCCESS;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(private mobileService: MobileWebViewService, @Optional() private modal: NzModalRef) {
	}

	ngOnInit(): void {
		this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.title = this.modal.componentInstance?.data?.title;
		this.description = this.modal.componentInstance?.data?.description;
		this.submitButtonName = this.modal?.componentInstance?.data?.submitButtonName || 'Try Again';
		this.canCalButtonName = this.modal?.componentInstance?.data?.canCalButtonName || 'Back';
		this.isSuspended = this.modal?.componentInstance?.data?.isSuspended;
		this.suspensionReleaseTime = this.modal?.componentInstance?.data?.suspensionReleaseTime;
		this.showFullButton = this.modal?.componentInstance?.data?.showFullButton;
		this.actionAfterModalClose = this.modal?.componentInstance?.data?.actionAfterModalClose || ActionAfterModalClose.CLOSE;
	}

	closeModal() {
		this.modal.destroy();
	}

	continue() {
		this.modal.componentInstance.callback(this.actionAfterModalClose);
	}

}
